import React, { useEffect, useState } from "react";
import { getRecharges } from "../../service/api";
import TopBar from "./TopBar";

function PurchaseToken() {
  const [rechargeList, setRechargeList] = useState([]);
  const [user_data, setUser_data] = useState();

  useEffect(async () => {
    const user_data = JSON.parse(sessionStorage.getItem("userdata"));
    setUser_data(user_data);

    const rechargeList = await getRecharges();
    setRechargeList(rechargeList);
  }, []);

  const payNow = (e) => {
    let options = {
      key: "rzp_test_yqIFpKOd9SawPZ",
      amount: e.fees * 100,
      currency: "INR",
      name: "Magic Moments",
      description: "Premium Subscription",
      timeout: 60,
      handler: () => alert("Payment Successful"),
      prefill: {
        name: user_data.fullName,
        email: user_data.email,
        contact: user_data.phone,
      },
      theme: {
        color: "#e23744",
      },
    };

    let razorpay = new window.Razorpay(options);
    razorpay.open();
  };

  return (
    <div className="bg h-full min-h-screen">
      <TopBar />

      <div className="grid grid-cols-3 gap-5 p-5">
        {rechargeList.map((option, index) => (
          <div
            key={index}
            className="flex flex-col bg-white rounded-lg items-center px-10 py-3.5 font-semibold gap-2"
          >
            <div className="flex items-center w-full justify-between">
              <h1>Coins: {option.coins}</h1>
              <h3>Expiry: {option.expiry}</h3>
            </div>
            <div className="flex items-center w-full justify-between">
              <h1>Fees: {option.fees}</h1>
              <button
                className="bg shadow-lg rounded-lg px-2.5 py-0.5 font-semibold text-slate-200 text-sm"
                onClick={() => payNow(option)}
              >
                Pay
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PurchaseToken;
